const IssuePreview = () => import("@/views/base/IssuePreview.vue");
const IssueMap = () => import("@/views/base/IssueMap.vue");
const IssueProfile = () => import("@/views/base/IssueProfile.vue");

const issuesRoute = {
  mainRoute: "base/IssuesPreview",
  children: [
    {
      path: "base/IssuesPreview",
      name: "Issues Preview",
      component: IssuePreview
    },
    {
      path: "issue",
      name: "Issues Profile",
      component: IssueProfile,
      props(route) {
        return route.query || {};
      }
    },
    {
      path: "base/IssuesMap",
      name: "Map By Region",
      component: IssueMap
    }
  ]
};

export default issuesRoute;
